var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusinessgrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "businessgrow",
    transform: "translate(-16 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4926",
    "data-name": "Path 4926",
    d: "M151.043,246V218.5a2.5,2.5,0,0,0-2.507-2.5H138.507A2.5,2.5,0,0,0,136,218.5V246h5.014V221h5.014v25Z",
    transform: "translate(-82.393 -137.5)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4927",
    "data-name": "Path 4927",
    d: "M279.043,261.5v-35a2.5,2.5,0,0,0-2.507-2.5H266.507A2.5,2.5,0,0,0,264,226.5v35h5.014V229h5.014v32.5Z",
    transform: "translate(-170.278 -143)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4928",
    "data-name": "Path 4928",
    d: "M215.043,239.5v-45a2.5,2.5,0,0,0-2.507-2.5H202.507A2.5,2.5,0,0,0,200,194.5v40h5.014V197h5.014v42.5Z",
    transform: "translate(-126.335 -121)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4929",
    "data-name": "Path 4929",
    d: "M343.043,219.5v-25a2.5,2.5,0,0,0-2.507-2.5H330.507A2.5,2.5,0,0,0,328,194.5V222h5.014V197h5.014v22.5Z",
    transform: "translate(-214.221 -121)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4930",
    "data-name": "Path 4930",
    d: "M407.043,184V146.5a2.5,2.5,0,0,0-2.507-2.5H394.507A2.5,2.5,0,0,0,392,146.5V184h5.014V149h5.014v35Z",
    transform: "translate(-258.163 -88)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4931",
    "data-name": "Path 4931",
    d: "M120.256,72.768a2.512,2.512,0,0,0,3.546,0l20.7-20.637,20.8,23.042a2.509,2.509,0,0,0,1.8.827h.066a2.511,2.511,0,0,0,1.773-.732l33.327-33.232V48.5a2.5,2.5,0,0,0,2.507,2.5h10.029a2.5,2.5,0,0,0,2.507-2.5v-30a2.5,2.5,0,0,0-2.507-2.5H184.708a2.5,2.5,0,0,0-2.507,2.5v10a2.5,2.5,0,0,0,2.507,2.5h6.483L167.253,54.869l-20.8-23.042a2.512,2.512,0,0,0-3.541-.186c-.033.029-.065.059-.1.09l-30.086,30a2.5,2.5,0,0,0,0,3.536ZM144.5,37.131l20.8,23.042a2.512,2.512,0,0,0,3.541.186c.033-.029.065-.059.1-.09l30.086-30A2.5,2.5,0,0,0,197.243,26H187.215V21h25.072V46h-5.014V36a2.509,2.509,0,0,0-4.28-1.768L167.253,69.869l-20.8-23.042a2.509,2.509,0,0,0-1.8-.827h-.066a2.511,2.511,0,0,0-1.773.732L122.029,67.464,118.053,63.5Z",
    transform: "translate(-65.914)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4932",
    "data-name": "Path 4932",
    d: "M38.564,350.143v-5h7.521a2.5,2.5,0,0,0,2.507-2.5v-6.55a63.163,63.163,0,0,0,87.195-1.86l27.4-27.322a9.581,9.581,0,0,0-11.726-14.975,9.784,9.784,0,0,0-16.042-.533l-1.063,1.422a10.776,10.776,0,0,0-16.175,3.713q-.1.2-.188.4l-6.32,14a11.248,11.248,0,0,0-4.162-.8H77.21l-4.28-4.268a20.312,20.312,0,0,0-24.337-3.254v-2.478a2.5,2.5,0,0,0-2.507-2.5H38.564v-2.5a2.5,2.5,0,0,0-2.507-2.5H16v5H33.55v50H16v5H36.057A2.5,2.5,0,0,0,38.564,350.143ZM145.7,293.158a4.733,4.733,0,0,1,1.92,2.2l-19.893,19.836a42.414,42.414,0,0,1-8.939,6.819l20.648-27.622A4.753,4.753,0,0,1,145.7,293.158Zm-23.138,5.828a5.753,5.753,0,0,1,7.6-2.874c.071.032.142.065.212.1a5.757,5.757,0,0,1,.983.623l-14.113,18.88a11.305,11.305,0,0,0-1.382-1.878ZM69.385,309.41l5.014,5a2.511,2.511,0,0,0,1.773.732h31.34a6.25,6.25,0,1,1,0,12.5H76.172v5h31.34a11.266,11.266,0,0,0,8.261-3.6,47.365,47.365,0,0,0,15.505-10.314l21.882-21.819a4.578,4.578,0,0,1,6.484,6.465l-27.4,27.322a58.139,58.139,0,0,1-82.054,0l-1.595-1.59V308.73A15.27,15.27,0,0,1,69.385,309.41Zm-25.806-6.768v37.5H38.564v-37.5Z",
    transform: "translate(0 -186.643)",
    fill: "#ff725e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessgrow);
export default __webpack_public_path__ + "static/media/businessgrow.9cf141c87fcf641f8010b65ab28030fd.svg";
export { ForwardRef as ReactComponent };